export let pendingAutoOpenFlexPaneId: string | undefined = undefined;

export function setPendingAutoOpenFlexPaneId(id: string | undefined): void {
    pendingAutoOpenFlexPaneId = id;
}

export function getPendingAutoOpenFlexPaneId(): string | undefined {
    return pendingAutoOpenFlexPaneId;
}
